var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expandable-control",class:_vm.isOpen ? 'expanded' : 'collapsed',on:{"click":_vm.toggle}},[_vm._v("\n  "+_vm._s(_vm.text)+" "),_c('i',{class:[_vm.icon]})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48090580","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/analytics/components/ExpandableControl.vue
// module id = null
// module chunks = 